import { APIService } from '../../shared/services/APIService';

export class TranslationService extends APIService {
  async get(code: string) {
    return this.http.get<any>(`/translations/${code}`);
  }
}
